import ModeButton from 'components/Buttons/ModeButton';

const TextToggle = ({
  options = ['1', '2'],
  value,
  setValue,

  activeStyle,
  inactiveStyle,
  buttonClassName = '',
  wrapperClassName = '',

  ...rest
}) => {
  return (
    <ModeButton
      options={options}
      onChange={(val) => setValue(val === options[1])}
      selectedOption={value ? options[1] : options[0]}
      activeStyle={activeStyle}
      inactiveStyle={inactiveStyle}
      buttonClassName={buttonClassName}
      wrapperClassName={wrapperClassName}
      {...rest}
    />
  );
};

export default TextToggle;
